import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';

var MultipleAnswerComponent = /** @class */ (function (_super) {
    __extends(MultipleAnswerComponent, _super);
    function MultipleAnswerComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = [];
        return _this;
    }
    MultipleAnswerComponent.prototype.setAnswer = function (text, selected) {
        if (!selected) {
            var index = this.value.indexOf(text);
            if (index > -1) {
                this.value.splice(index, 1);
            }
        }
        else {
            this.value.push(text);
        }
        this.emitStandAloneChange(this.value, true);
    };
    MultipleAnswerComponent.prototype.initialize = function () {
        this.emitStandAloneChange(this.value, false);
    };
    MultipleAnswerComponent.prototype.triggerValidationOnNextStep = function () {
        if (!this.nextStepBlocked) {
            return;
        }
        this.emitStandAloneChange(this.value, true);
    };
    MultipleAnswerComponent.prototype.isValid = function (value) {
        return this.question.isOptional || value.length > 0;
    };
    MultipleAnswerComponent.prototype.emitStandAloneChange = function (value, touched) {
        var modelClone = [];
        value.forEach(function (value) { return modelClone.push(value); });
        return {
            value: modelClone,
            isValid: this.isValid(modelClone),
            touched: touched,
        };
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], MultipleAnswerComponent.prototype, "question", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], MultipleAnswerComponent.prototype, "nextStepBlocked", void 0);
    __decorate([
        Watch('question'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MultipleAnswerComponent.prototype, "initialize", null);
    __decorate([
        Watch('nextStepBlocked', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MultipleAnswerComponent.prototype, "triggerValidationOnNextStep", null);
    __decorate([
        Emit('stand-alone-change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, Boolean]),
        __metadata("design:returntype", void 0)
    ], MultipleAnswerComponent.prototype, "emitStandAloneChange", null);
    MultipleAnswerComponent = __decorate([
        Component({
            name: 'multiple-answer',
        })
    ], MultipleAnswerComponent);
    return MultipleAnswerComponent;
}(Mixins(MagicConfigMixin)));

export default MultipleAnswerComponent;
